import { SxProps, Theme } from "@mui/material";

export const notFoundBoxStyle: SxProps<Theme> = {
  p: 3,
  color: "text.secondary"
};

export const errorBoxStyle: SxProps<Theme> = {
  p: 3
};

export const retryButtonStyle: SxProps<Theme> = {
  mt: 2
};

export const loadingFallbackStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  p: 4,
  width: "100%"
};
